import {ModuleWithProviders, NgModule} from '@angular/core';
import {APP_BASE_HREF, CommonModule} from '@angular/common';
import {LoginComponent} from './component/login/login.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {SelectModule} from 'ng-select';
import {ToasterModule, ToasterService} from 'angular2-toaster';
import {RouterModule} from '@angular/router';
import {AppHeaderModule} from '@coreui/angular';
import {SharedModule} from 'src/shared/shared.module';
import {AccessDeniedComponent} from './component/access-denied/access-denied.component';
import {AddHttpHeaderInterceptor} from './http-interceptor/custom-header-http';
import {CookieService} from 'ngx-cookie-service';
import {AuthService} from './service/auth.service';
import {AuthRouter} from './service/auth.router';
import {LoaderService} from 'src/service/loader-service';
import {LoaderComponent} from 'src/shared/loader/loader.component';
import {AuthenticationRouting} from './authentication.routing';

@NgModule({
  declarations: [LoginComponent, AccessDeniedComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    SelectModule,
    ToasterModule,
    RouterModule,
    AppHeaderModule,
    SharedModule,
    AuthenticationRouting
  ],
  providers: [
    {provide: APP_BASE_HREF, useValue: '/'},
    // {provide: ErrorHandler, useClass: CustomErrorHandlerService},
    {provide: HTTP_INTERCEPTORS, useClass: AddHttpHeaderInterceptor, multi: true},
    CookieService,
    ToasterService
  ]
})
export class AuthenticationModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: AuthenticationModule,
      providers: [
        AuthService,
        AuthRouter,
        LoaderService,
        LoaderComponent,
      ]
    }
  }
}
